module.exports = __webpack_public_path__ + "static/media/Accademia - DK Chocolate_White.49c90bd5.jpg";